module.exports = __webpack_public_path__ + "img/contact.cf47235b.jpg";